import {
  RectangleWithCustomRadius,
  type RectangleWithCustomRadiusProps,
} from '../components/rectangle-with-custom-radius/RectangleWithCustomRadius';

type VerticalRectangleWithCustomRadiusProps = Omit<
  RectangleWithCustomRadiusProps,
  'animationDirection'
> & { animateFromY?: number | undefined };

export const VerticalRectangleWithCustomRadius = (
  props: VerticalRectangleWithCustomRadiusProps,
) => {
  const { animateFromY, ...rest } = props;
  return (
    <RectangleWithCustomRadius
      {...rest}
      animationDirection={{ type: 'vertical', fromY: animateFromY }}
    />
  );
};
